.media-default-skin {
  /* Colors */
  --media-internal-accent-color: var(--media-accent-color, var(--media-default-accent-color));
  --media-accent-contrast-color: contrast-color(var(--media-internal-accent-color));
  --media-accent-background-color: var(
    --media-accent-color,
    oklch(from var(--media-default-accent-color) l c h / calc(alpha * 0.1))
  );
  --media-internal-accent-text-color: var(
    --media-accent-text-color,
    contrast-color(var(--media-accent-color, oklch(0 0 0)))
  );
  --media-shadow-current-color: oklch(from currentColor 0 0 0 / clamp(0, calc((l - 0.5) * 0.5), 0.15));
  --media-shadow-subtle-current-color: oklch(from var(--media-shadow-current-color) l c h / calc(alpha * 0.4));
  --media-scrollbar-thumb-color: oklch(from currentColor l c h / 0.3);

  /* Scaling - used in video fullscreen to scale the UI. */
  --media-scale: 1;
  /* Fixed scaling unit to avoid inheriting the document's root font size. This must be a CSS <length>. */
  --media-internal-scale-unit: var(--media-scale-unit, 16px);
  --media-size: calc(var(--media-internal-scale-unit) * var(--media-scale));
  /* Create a Tailwind-like spacing unit where 1 equals 4px with default scaling. */
  --media-spacing: calc(var(--media-size) / 4);

  /* Font sizes */
  --media-font-size-medium: calc(0.9375 * var(--media-size)); /* 15px */
  --media-font-size-base: calc(0.8125 * var(--media-size)); /* 13px */
  --media-font-size-small: calc(0.6875 * var(--media-size)); /* 11px */
  --media-font-size-tiny: calc(0.5625 * var(--media-size)); /* 9px */
  --media-icon-size: calc(1.125 * var(--media-size)); /* 18px */

  /* Radii */
  --media-container-border-radius: var(--media-border-radius, 1.75rem);

  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  container: media-root / inline-size;
  font-family:
    Inter Variable,
    Inter,
    ui-sans-serif,
    system-ui,
    sans-serif;
  font-size: var(--media-font-size-base);
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
  line-height: 1.5;
  letter-spacing: normal;
  outline: 2px solid transparent;
  outline-offset: -4px;
  scrollbar-color: var(--media-scrollbar-thumb-color) transparent;
  scrollbar-width: thin;
  border-radius: var(--media-container-border-radius, 1.75rem);
  isolation: isolate;
  transition-timing-function: ease-out;
  transition-duration: 100ms;
  transition-property: outline-offset, outline-color;

  &:focus-visible {
    outline-color: var(--media-focus-ring-color);
    outline-offset: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--media-scrollbar-thumb-color);
    border-radius: 9999px;
  }

  @media (prefers-reduced-transparency: reduce) or (prefers-contrast: more) {
    --media-scrollbar-thumb-color: oklch(from currentColor l c h / 0.8);
    scrollbar-width: auto;
  }
}
